import locationDistanceAllComponent from './location_distance.all.component';

let locationDistanceAllModule = angular.module('locationDistanceAll', [])
    .component('locationDistanceAll', locationDistanceAllComponent)
    .name;

export default locationDistanceAllModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/location_distance/all/index.js